import React, { useEffect, useState } from "react";
import { CalendarCheck } from "lucide-react";
import { api } from "@/lib/api";
import { formatDeShort } from "@/lib/date";

export const MyPhasesWidget = () => {
  const [phases, setPhases] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/my-phases").then(({ data }) => setPhases(data.phases || [])).finally(() => setLoading(false));
  }, []);

  if (loading || phases.length === 0) return null;

  return (
    <div className="border border-slate-200 bg-white p-6" data-testid="my-phases-widget">
      <div className="flex items-center gap-2 mb-1">
        <CalendarCheck size={16} strokeWidth={1.5} className="text-slate-500" />
        <h3 className="text-sm font-bold uppercase tracking-overline text-slate-500">Meine Kunden — voraussichtliches Ende</h3>
      </div>
      <p className="text-xs text-slate-500 mb-4">
        Automatisch aus dem UE-Anteil deiner Abschnitte berechnet. Sobald ein Kunde erledigt ist, hast du wieder Platz.
      </p>
      <div className="divide-y divide-slate-100">
        {phases.map((p) => (
          <div key={`${p.client_id}-${p.phase_label || "g"}`} className="flex items-center justify-between py-2.5" data-testid="my-phases-row">
            <div>
              <div className="text-sm font-medium text-slate-900">{p.name}</div>
              {p.phase_label && <div className="text-xs text-slate-500">{p.phase_label}</div>}
            </div>
            <div className="text-right">
              <span
                className={`inline-block px-2 py-0.5 text-xs font-medium ${
                  p.status === "laufend" ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"
                }`}
              >
                {p.status === "laufend" ? "Läuft" : "Bevorstehend"}
              </span>
              <div className="text-xs text-slate-500 mt-1">{p.start_date ? `ab ${formatDeShort(p.start_date)} · ` : ""}Übergabe bis {formatDeShort(p.finish_date)}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyPhasesWidget;
